<template>
  <div class="notice">
    <div class="notice-top">
      <div class="top-left">
        <div class="notice-search">
          <search :placeholder="placeholder" @search="search" />
        </div>
        <!-- <div class="notice-select">
          <el-select
            v-model="selectText"
            placeholder="选择公告"
            @change="refresh"
          >
            <el-option
              :label="item.label"
              :value="item.label"
              v-for="(item, index) in selectList"
              :key="index"
            ></el-option>
          </el-select>
        </div> -->
        <div class="notice-select">
          <el-select v-model="crowdSelectText" placeholder="选择分组" @change="crowdChange" clearable>
            <el-option :label="item.label" :value="item.value" v-for="(item, index) in crowdSelectList"
              :key="index"></el-option>
          </el-select>
        </div>
        <!-- <div class="notice-select">
          <el-cascader
            v-model="className"
            placeholder="选择年级/班级"
            :props="classProps"
            :options="classSelect"
            clearable
            @change="classChange"
          ></el-cascader>
        </div> -->
        <!-- 年级 -->
        <div class="notice-select">
          <el-select v-model="gradeId" placeholder="选择年级" @change="gradeChange" clearable>
            <el-option :label="item.gradeName" :value="item.gradeId" v-for="(item, index) in gradeList"
              :key="index"></el-option>
          </el-select>
        </div>
        <!-- 班级 -->
        <div class="notice-select">
          <el-select v-model="classId" placeholder="选择班级" @change="classChange" clearable>
            <div slot="empty" style="
                padding: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #c0c4cc;
              ">
              <div>未选择年级</div>
            </div>
            <el-option :label="item.className" :value="item.classId" v-for="(item, index) in classList" :key="index">
            </el-option>
          </el-select>
        </div>
        <div class="notice-select">
          <el-select v-model="tpSelectText" placeholder="选择接收者" @change="tpChange" clearable>
            <el-option :label="item.label" :value="item.value" v-for="(item, index) in tpSelectList"
              :key="index"></el-option>
          </el-select>
        </div>
        <div class="notice-select">
          <el-select v-model="typeSelectText" placeholder="选择公告类型" @change="refresh" clearable>
            <el-option :label="item.label" :value="item.label" v-for="(item, index) in typeSelectList"
              :key="index"></el-option>
          </el-select>
        </div>
        <div class="notice-select">
          <el-select v-model="noticeQueryData.semester" placeholder="学期" clearable @change="semesterChangeHandle">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </div>
        <div class="notice-select">
          <!-- <el-date-picker style="width: 100px; margin-left: 20px" v-model="noticeQueryData.schoolYear" type="year"
            placeholder="学年" @change="schoolYearChangeHandle">
          </el-date-picker> -->
          <year-range-picker style="width: 240px;" v-model="noticeQueryData.schoolYear"
            @change="schoolYearChangeHandle" />
        </div>
      </div>
      <div class="notice-operation-part-container">
        <button class="button add" @click="noticeAddShow = true" v-hasPermi="'sc:news:add'">
          <i class="iconfont icon-add" />发布公告
        </button>
      </div>
    </div>
    <div class="topbar-tabs">
      <div class="tab-item" :class="currentCourseItem == index ? 'current-item' : ''"
        v-for="(item, index) in angleSelectList" :key="index" @click="changeCurrentTabItem(index, item.value)">
        {{ item.label }}
      </div>
    </div>
    <div class="notice-list" v-bitmap="getNoticeResult">
      <noticeItem v-for="(item, index) in noticeList" :noticeStatusList="noticeStatusList" :item="item" :key="index"
        @deleteClick="deleteClick" />
    </div>
    <!-- 分页 -->
    <div class="notice-pagination">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageSize)" @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange" />
    </div>
    <noticeAdd v-show="noticeAddShow" :noticeMethodList="noticeMethodList" :noticeAddShow.sync="noticeAddShow"
      @refresh="refresh" :gradeSelect="gradeList" :crowdSelectList="crowdSelectList" :semesterOptions="semesterOptions"
      :schoolYear="noticeQueryData.schoolYear" :semester="noticeQueryData.semester" />
  </div>
</template>

<script>
import noticeItem from "./components/notice-item/notice-item.vue";
import pagination from "../../components/pagination/pagination.vue";
import noticeAdd from "./components/notice-add/notice-add.vue";
import search from "@/components/search/search.vue";

export default {
  name: "",
  data() {
    return {
      getNoticeResult: "nullData",
      loading: false,
      // 分页参数
      total: 0, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 20, // 每页条数
      noticeList: [],
      gradeId: "",
      classId: "",
      noticeAddShow: false, // 发布公告dialog
      placeholder: "输入标题",
      queryTitle: "",
      selectList: [
        {
          label: "全部",
        },
        {
          label: "我发布的",
        },
      ],
      angleSelectList: [],
      angleSelectListF: [
        {
          label: "我接收的",
          value: 1,
        },
        {
          label: "我发布的",
          value: 2,
        },
      ],
      angleSelectListS: [
        {
          label: "我接收的",
          value: 1,
        },
      ],
      tpSelectList: [
        {
          label: "全部师生",
          value: 0,
        },
        {
          label: "家长接收",
          value: 1,
        },
        {
          label: "老师接收",
          value: 2,
        },
      ],
      typeSelectList: [
        {
          label: "普通",
        },
        {
          label: "重要",
        },
        {
          label: "紧急",
        },
      ],
      crowdSelectList: [],
      selectText: "全部",
      typeSelectText: "", // 公告类型
      angleSelectText: "我发布的",
      crowdSelectText: "", // 分组
      tpSelectText: "", // 接收者
      senderId: "",
      noticeQueryData: {
        inquireType: 1,
        crowdId: "",
        newsGroup: 2,
        schoolYear: "", // 学年
        semester: "", // 学期
      },
      queryData: {
        crowdName: "",
        status: 0,
      },
      currentCourseItem: 0,
      gradeList: [],
      classList: [],
      semesterOptions: [],
      noticeMethodList: [], // 公告发布方式
      noticeStatusList: [], // 公告发布状态
    };
  },
  components: {
    noticeItem,
    pagination,
    noticeAdd,
    search,
  },
  created() {
    // this.angleSelectListF.push({
    //   label: "全部",
    //   value: 3,
    // });
    this.angleSelectList = this.angleSelectListF;
    // if (this.user.roleId == 1) {
    //   this.angleSelectListF.push({
    //     label: "全部",
    //     value: 3,
    //   });
    // }
    // if (this.user.roleId == 1 || this.classInfo.currentClass.isCharge == 1) {
    //   this.angleSelectList = this.angleSelectListF;
    // } else {
    //   this.angleSelectList = this.angleSelectListS;
    // }
    // 获取公告列表
    this.getSchoolDetails();
    this.getGradeList();
    this.getTeacherGroupList();
    this.getDictType();
    this.getNoticeReleaseMethod();
    this.getNoticeReleaseStatus();
  },
  watch: {
    "classInfo.currentClass.classId": function (newValue, oldValue) {
      // 监听到数据变化时执行的操作
      if (this.user.roleId == 1 || this.classInfo.currentClass.isCharge == 1) {
        this.angleSelectList = this.angleSelectListF;
      } else {
        this.angleSelectList = this.angleSelectListS;
      }
      this.getNewsList();
    },
  },
  methods: {
    // 公告发布方式
    getNoticeReleaseMethod() {
      this.get(this.$url.getDictType + "/sc_public_type").then((res) => {
        // console.log("获取公告发布方式==>", res);
        if (res.code !== 200) return;
        this.noticeMethodList = res.data;
      });
    },
    // 公告发状态
    getNoticeReleaseStatus() {
      this.get(this.$url.getDictType + "/sc_public_status").then((res) => {
        // console.log("获取公告发状态==>", res);
        if (res.code !== 200) return;
        this.noticeStatusList = res.data;
      });
    },
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        let schoolInfo = res.data;
        this.noticeQueryData.semester = schoolInfo.semester;
        this.noticeQueryData.schoolYear = schoolInfo.schoolYear;
        // 先获取学年学期，再获取公告
        this.getNewsList();
      });
    },
    // 获取学期类型选择列表数据
    getDictType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    // classChange(e) {
    //   this.refresh();
    // },
    gradeChange(e) {
      if (e == "") {
        this.classList = [];
      } else {
        this.classList = this.gradeList.find(
          (item) => item.gradeId == e
        ).schoolClassList;
      }
      this.classId = "";
      this.gradeId = e;

      this.getNewsList();
    },
    classChange(e) {
      this.classId = e;
      this.getNewsList();
    },
    schoolYearChangeHandle(e) {
      // console.log(e);
      // this.noticeQueryData.schoolYear = e ? "" + e.getFullYear() : "";
      this.getNewsList();
    },
    semesterChangeHandle(e) {
      this.noticeQueryData.semester = e;
      this.getNewsList();
    },
    // 获取年级
    getGradeList() {
      this.get(this.$url.getgradeList, {
        schoolId: this.school.id,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.gradeList = res.data;
          } else {
            return this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          // console.log(err)
          // this.$message.error("获取年级信息失败，请稍后再试");
        });
    },
    // 获取公告列表
    getNewsList() {
      // this.getNoticeResult = "loading";
      // 查询全部时senderId = ''，我发布的senderId为当前用户id

      let { newsGroup, inquireType, crowdId, schoolYear, semester } =
        this.noticeQueryData;
      newsGroup = this.user.roleId == 1 ? newsGroup : 1;
      this.createBy = inquireType == 2 ? this.user.id : "";
      let data = {
        schoolId: this.user.schoolId,
        newsGroup: this.tpSelectText,
        title: this.queryTitle,
        //发布人过滤，（如只看自己发布的）
        createBy: this.createBy, //会被`1只看我要接收的`覆盖
        // 2管理员视角 1只看我要接收的（排除我发布的）
        inquireType,
        crowdId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        newsType: this.typeSelectText,
        classId: this.classId,
        gradeId: this.gradeId,
        schoolYear,
        semester,
        // senderName: this.user.teacherName,
        status: "",
      };
      if (this.noticeQueryData.inquireType == 1) {
        data.status = 1;
      } else {
        delete data.status;
      }
      // 管理员classId传0，教师传当前班级的classId
      // if (this.user.roleId !== 1) {
      //   if (crowdId == "") {
      //     data.classId = this.classInfo.currentClass.classId;
      //     data.gradeId = this.classInfo.currentClass.gradeId;
      //   }
      // } else {
      //   if (this.className.length) {
      //     data.classId = this.className[1].classId;
      //     data.gradeId = this.className[0].gradeId;
      //   }
      // }

      this.post(this.$url.getNewsList, data)
        .then((res) => {
          // console.log(res);
          if (res.code != 200) {
            this.$message.error("获取公告失败，请稍后再试");
            return (this.getNoticeResult = "error");
          }
          let data = res;
          this.total = data.total;
          this.total > 0
            ? (this.getNoticeResult = "success")
            : (this.getNoticeResult = "nullData");
          // console.log(data);
          this.noticeList = data.rows;
        })
        .catch((err) => {
          // console.log(err);
          // this.getNoticeResult = "error";
          // this.$message.error("获取公告失败，请稍后再试");
        });
    },
    getTeacherGroupList() {
      let { crowdName, status } = this.queryData;
      let schoolId = this.user.schoolId;
      this.get(this.$url.getTeacherGroupList, {
        crowdName,
        // crowdLeader,
        status,
        schoolId,
        // leaderId,
        // createBy,
      })
        .then((res) => {
          // console.log("获取教师分组==>", res);
          let data = res.rows;
          data.map((item) => {
            this.crowdSelectList.push({
              label: item.crowdName,
              value: item.id,
            });
          });
        })
        .catch((err) => {
          // console.log("获取教师分组报错==>", err);
        });
    },
    // 切换状态
    changeCurrentTabItem(tabsIndex, val) {
      // console.log(tabsIndex);
      this.currentCourseItem = tabsIndex;
      this.noticeQueryData.inquireType = val;
      this.refresh();
    },
    crowdChange(e) {
      this.noticeQueryData.crowdId = e;
      this.refresh();
    },
    tpChange(e) {
      this.noticeQueryData.newsGroup =
        e == "全部" ? 0 : e == "老师接收" ? 2 : 1;
      this.refresh();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getNewsList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getNewsList();
    },
    // 删除公告
    deleteClick(option) {
      this.delete(`${this.$url.deleteNews}/${option.id}`)
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.refresh(); // 刷新列表
          } else {
            this.$message.error("删除失败");
          }
        })
        .catch((err) => {
          this.$message.error("删除失败，请稍后再试");
        });
    },
    search(query) {
      this.queryTitle = query;
      // 刷新
      this.refresh();
    },
    // 刷新
    refresh() {
      this.pageNum = 1;
      this.noticeList = [];
      this.getNewsList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./notice.scss";
</style>
